import type { ReactNode } from "react";
import Link from "next/link";

/** a block's heading, with a short link on its right when there is more of it elsewhere */
export function SectionHead({ title, eyebrow, more }: { title: ReactNode; eyebrow?: ReactNode; more?: { href: string; label: string } }) {
  return (
    <div className="mb-2.5 flex items-baseline justify-between gap-3 px-0.5">
      <div>
        {eyebrow && <span className="mb-0.5 block text-[11.5px] font-bold uppercase tracking-[0.07em] text-amber">{eyebrow}</span>}
        <h2 className="text-[17px] font-bold desk:text-[21px]">{title}</h2>
      </div>
      {more && (
        <Link href={more.href} className="shrink-0 text-[13px] font-bold text-brand desk:text-[14px]">
          {more.label}
        </Link>
      )}
    </div>
  );
}

/** a snippet's text, as public-api rendered it from Quill: paragraphs close together, links underlined */
export function Html({ html, className = "" }: { html: string; className?: string }) {
  if (!html) return null;
  return <div className={`[&_a]:underline [&_p]:m-0 [&_p+p]:mt-1 [&_strong]:font-bold ${className}`} dangerouslySetInnerHTML={{ __html: html }} />;
}

/** a round tinted disc with an icon in it, as the boxes and the shortcuts have */
export function IconDisc({ children, tone, size = 36, className = "" }: { children: ReactNode; tone: string; size?: number; className?: string }) {
  return (
    <span className={`flex shrink-0 items-center justify-center rounded-full ${tone} ${className}`} style={{ width: size, height: size }}>
      {children}
    </span>
  );
}

// the tints the kinds of event and the boxes share (EventCard's KINDS say the same of the pills)
export const TONES = {
  green: "bg-brand-soft text-brand-dark",
  amber: "bg-amber-soft text-[#854f0b]",
  slate: "bg-secondary-dark text-white",
  blue: "bg-[#e6eef5] text-price",
} as const;
